// ═══════════════════════════════════════════════════════════════
// One keyed-lookup model bound to LookupTable entities (F-024 / F-032)
//
// Every lookup surface — rules (validate / auto-fill condition source + Then
// action) and export substitution — uses this ONE shape instead of ad-hoc
// inline match/output pairs or free-text table names. A binding names a table
// by id, the column to match on, the value to match (a literal or a field
// reference), and the column to return. This makes "match {employer_doc_no}
// against the CA EDD Employers table's EIN column, return employer_name"
// expressible and id-bound (no typo drift).
// ═══════════════════════════════════════════════════════════════
/** True when a value object is a complete LookupBinding (id + columns set). */
export function isLookupBinding(v) {
    if (!v || typeof v !== "object")
        return false;
    const b = v;
    return (typeof b.tableId === "string" &&
        typeof b.matchColumn === "string" &&
        typeof b.returnColumn === "string" &&
        !!b.matchValue && typeof b.matchValue === "object");
}
/** Resolve the literal match string for a binding given the row's field values. */
export function resolveMatchString(matchValue, fieldValues) {
    if (matchValue.kind === "literal")
        return matchValue.value ?? "";
    return fieldValues[matchValue.name] ?? "";
}
/**
 * Resolve a keyed lookup: find the row whose `matchColumn` equals the resolved
 * match string (case-insensitive), and return its `returnColumn` value. Returns
 * `null` when the table is missing or no row matches — the caller (rule
 * on-failure / export default) decides what a miss means.
 */
export function resolveLookupBinding(binding, table, fieldValues) {
    if (!table)
        return null;
    const target = resolveMatchString(binding.matchValue, fieldValues).toLowerCase();
    for (const row of table.rows) {
        const cell = row[binding.matchColumn];
        if (cell !== undefined && cell !== null && String(cell).toLowerCase() === target) {
            const out = row[binding.returnColumn];
            return out === undefined || out === null ? null : String(out);
        }
    }
    return null;
}
//# sourceMappingURL=lookup-binding.js.map